<template>
	<div>
		
		<v-card>
			<v-tabs v-model="tab" grow icons-and-text color="green">
				<v-tab>
					Vídeo
					<v-icon v-if="showPlayer">far fa-play</v-icon>
					<v-icon v-else-if="!temAula">far fa-check</v-icon>
					<v-icon v-else>far fa-circle-notch fa-spin</v-icon>
				</v-tab>
				<v-tab>
					Aulas
					<v-icon>far fa-books</v-icon>
				</v-tab>
				<v-tab>
					O curso
					<v-icon>far fa-chalkboard</v-icon>
				</v-tab>
			</v-tabs>

			<v-tabs-items v-model="tab">
				<v-tab-item>
					<PlayerFull
						:aula="aula"
						:userCursoId="curso.user_curso_id"
						v-if="showPlayer"
					></PlayerFull>
					<v-card class="mb-4" v-else-if="!temAula">
						<v-card-title class="brown--text">
							<span class="headline">
								<v-icon color="brown" dense left>far fa-check</v-icon>
								Parabéns
							</span>
						</v-card-title>
						<v-card-text class="green--text text--darken-2">
							<h3>Todas as aulas foram assistidas!</h3>
							Você pode entrar no menu aulas e reassistir às que desejar
						</v-card-text>
					</v-card>
					<v-card class="mb-4" v-else>
						<v-card-title>
							<span class="headline">Carregando...</span>
						</v-card-title>
						<v-progress-linear
							indeterminate
							color="cyan"
							class="my-4"
						></v-progress-linear>
					</v-card>
				</v-tab-item>
				<v-tab-item>
					<v-expansion-panels v-if="materias" focusable hover class="mt-2 mb-4">
						<v-expansion-panel
							v-for="materia in materias"
							:key="materia.id"
							class="grey lighten-5"
						>
							<v-expansion-panel-header>
								<div class="title">
									<v-icon dense left v-if="materia.materia_completa!=null" color="brown" title="Matéria finalizada">far fa-books</v-icon>
									<v-icon dense left v-else>far fa-books</v-icon>
									{{ materia.nome }}
								</div>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-card
									v-for="aula in materia.aulas"
									:key="aula.id"
									class="mt-4 mb-4"
								>
									<v-card-subtitle class="headline">
										<v-btn
											class="mr-4 white--text"
											color="green"
											title="Abrir aula"
											v-if="aula.videos != null"
											@click="player(aula)"
										>
											<v-icon small>fas fa-play</v-icon></v-btn
										>
										<v-icon left v-if="aula.aula_completa!=null" color="brown" title="Aula assistida">far fa-chalkboard-teacher</v-icon>
										<v-icon left v-else>far fa-chalkboard-teacher</v-icon>
										{{ aula.nome }}
									</v-card-subtitle>
									<v-card-text>
										Acesso de {{ aula.data_inicio_formatada }} à {{ aula.data_final_formatada }}
									</v-card-text>
									<v-card-text
										v-if="aula.descricao"
										v-html="aula.descricao"
										class="ql-editor-custom ql-editor-custom-light"
									>
									</v-card-text>
								</v-card>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>

					<v-alert
						color="green-grey darken-1"
						dark
						border="right"
						icon="fas fa-empty-set"
						v-else
					>
						Sem aulas cadastradas até o momento
					</v-alert>
				</v-tab-item>
				<v-tab-item>
					<v-card-title class="headline">
						<v-icon left>far fa-chalkboard</v-icon> {{ curso.nome }}
					</v-card-title>
					<v-card-text
						v-if="curso.descricao"
						v-html="curso.descricao"
						class="ql-editor-custom ql-editor-custom-light"
					></v-card-text>
				</v-tab-item>
			</v-tabs-items>
		</v-card>
	</div>
</template>

<script>
import { mapState } from 'vuex'

import PlayerFull from '@/components/PlayerFull'


export default {
	components: {
		PlayerFull,
	},
	data() {
		return {
			server: 'user_data',
			materias: [],
			curso: {},
			cursoId: null,
			aula: null,
			showPlayer: false,
			tab: null,
			userCursoId: null,
			temAula: true,
		}
	},
	beforeRouteUpdate(to, from, next) {
		this.cursoId = to.params.id
		next()
	},
	computed: {
		...mapState(['user', 'XMLHttpRequest', 'searchAula', 'userPlayer']),
	},
	created() {
		this.cursoId = this.$route.params.id
	},
	watch: {
		cursoId() {
			this.getData()
		},
		searchAula(val) {
			if (val === true) {
				this.getData()
			}
		},
	},
	methods: {
		getData() {
			let formData = new FormData()
			formData.append('menu', this.server)
			formData.append('function', 'get_meu_curso')
			formData.append('user_id', this.user.id)
			formData.append('curso_id', this.cursoId)
			let vd = this
			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
					vd.$store.dispatch('searchAula', { value: false })
					if (response.data.error === 0) {
						vd.curso = response.data.curso
						vd.materias = response.data.materias
						vd.pegaVideo()
					} else {
						vd.$store.dispatch('errorServer', {
							data: response.data,
							destino: vd.$route.path,
						})
					}
				})
				.catch(function(response) {
					console.log('ERRO!! ' + response)
				})
		},
		pegaVideo(){
			let cont = 0
			let ordem = []
			let materiaId = []
			let keyTemp = []
			Object.entries(this.materias).forEach(([key, value]) => {
				let temp = this.materias[key].video_ordem
				if(temp !== null){ 
					ordem[cont] = temp
					materiaId[cont] = this.materias[key].id
					keyTemp[cont] = key
					cont++
				}
			})
			if(cont > 0){
				let response = this.materias[keyTemp[0]].aulas.filter(t => 
					t.curso_id == this.curso.id&& 
					t.materia_id == materiaId[0] &&
					t.ordenation == ordem[0]
				)
				this.player(response[0])
			}else{
				this.showPlayer = false
				this.temAula = false
			}
		},
		player(aula) {
			this.showPlayer = false
			this.aula = Object.assign({}, aula)
			setTimeout(() => {
				this.showPlayer = true
			}, 1000)
		},
		certificado(certificado){
			let formData = new FormData()
			formData.append('menu', this.server)
			formData.append('function', 'certificado')
			formData.append('user_id', this.user.id)
			formData.append('certificado', certificado)
			let vd = this
			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
					if (response.data.error === 0) {
						window.open(response.data.caminho, '_blank');
					} else {
						vd.$store.dispatch('errorServer', {
							data: response.data,
							destino: vd.$route.path,
						})
					}
				})
				.catch(function(response) {
					console.log('ERRO!! ' + response)
				})
		}
	},
}
</script>
<style lang="css">
.v-expansion-panel-content__wrap {
	padding: 0 10px 10px !important;
}
</style>
